import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AccountLanguage } from '@interfaces/HttpClient/AccountApiPublicModels';
import { GlobalVarService } from '@services/global-var.service';
import { TranslationService } from '@services/translation.service';
import { UserAuthorizationService } from '@services/user-authorization.service';

@Component({
	selector: 'app-language',
	templateUrl: './language.component.html',
	styleUrl: './language.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class LanguageComponent implements OnInit {

	@Input() isMobile = false;
	@Output() languageChange = new EventEmitter<AccountLanguage>();
	public model?: LanguageDto;
	private currentLanguage: AccountLanguage = AccountLanguage.German;
	public accountLanguage = AccountLanguage;


	constructor(
		private userAuthorizationService: UserAuthorizationService,
		private cdRef: ChangeDetectorRef,
		private globalVarService: GlobalVarService,
		private translationService: TranslationService
	) { }

	async ngOnInit() {

		if (!this.userAuthorizationService.isLoading()) {
			await this.initLanguage();
		}
		// Bei Anmeldung soll die Sprache geladen werden
		this.userAuthorizationService.refreshMenu.subscribe(async () => {
			await this.initLanguage();
		})
	}

	private async initLanguage() {
		this.currentLanguage = this.globalVarService.getTmpLanguage() ?? AccountLanguage.German;
		await this.translationService.switchAdminLanguage(this.currentLanguage);
		this.setModel();

		this.cdRef.markForCheck();
	}

	private setModel() {
		const path = "assets/orca/header/"
		if (this.currentLanguage === AccountLanguage.German) {
			this.model = {
				language: AccountLanguage.German,
				mobileImg: `${path}DE_active.svg`,
				desktopDeImg: `${path}DE_active.svg`,
				desktopEnImg: `${path}EN_inactive.svg`
			}
		}
		if (this.currentLanguage === AccountLanguage.English) {
			this.model = {
				language: AccountLanguage.English,
				mobileImg: `${path}EN_active.svg`,
				desktopDeImg: `${path}DE_inactive.svg`,
				desktopEnImg: `${path}EN_active.svg`
			}
		}
	}

	public async changeLanguage() {

		if (this.currentLanguage === AccountLanguage.German) {
			this.currentLanguage = AccountLanguage.English;
		} else if (this.currentLanguage === AccountLanguage.English) {
			this.currentLanguage = AccountLanguage.German;
		}

		await this.translationService.switchAdminLanguage(this.currentLanguage);
		this.setModel();
		this.globalVarService.setTmpLanguage(this.currentLanguage);
		this.cdRef.markForCheck();
		this.languageChange.emit(this.currentLanguage);
	}

}

interface LanguageDto {
	language: AccountLanguage,
	mobileImg: string;
	desktopEnImg: string;
	desktopDeImg: string;
} 
